import DefaultHeroDetailTemplate from './default-template';
import type { HeroDetailTemplateProps } from './types';

// Rellion owns this template entry and can evolve its layout without touching
// any other game. It starts from the platform's neutral character layout.
export default function RellionHeroDetailTemplate(
  props: HeroDetailTemplateProps,
) {
  return (
    <div data-hero-template="rellion">
      <DefaultHeroDetailTemplate {...props} />
    </div>
  );
}
